import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { Layout } from '../../../navigation/components/Layout/Layout';

export const Contact: FunctionComponent = () => {
  const onSendEmail = () => {
    window.open(`mailto:laflute.troyes@gmail.com`, '_blank');
  };

  return (
    <Layout title="Nous contacter" activeTab="contact">
      <Card>
        <CardContent>
          <Typography variant="h6">
            {"Vous avez des questions ? Besoin d'aide ?"}
          </Typography>
          <Typography variant="body1">
            {"Contactez nous par email à l'adresse suivante :"}
          </Typography>
          <Typography variant="body1">{'laflute.troyes@gmail.com'}</Typography>
        </CardContent>
        <CardActions>
          <Button variant="contained" onClick={onSendEmail}>
            Envoyer un email
          </Button>
        </CardActions>
      </Card>
    </Layout>
  );
};
